import { render, staticRenderFns } from "./choosecloudphone.vue?vue&type=template&id=1ef8db24&scoped=true"
import script from "./choosecloudphone.vue?vue&type=script&lang=js"
export * from "./choosecloudphone.vue?vue&type=script&lang=js"
import style0 from "./choosecloudphone.vue?vue&type=style&index=0&id=1ef8db24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8db24",
  null
  
)

export default component.exports